module.exports = __webpack_public_path__ + "static/media/logo-mkm-dark.9cd29932.svg";